  (function () {
    'use strict';

    function cgachInit(root) {
      if (!root || root.getAttribute('data-cgach-init') === '1') return;
      root.setAttribute('data-cgach-init', '1');

      /* ---------- données (variantes + libellés) ---------- */
      var variants = [];
      var cfg = { bouton: 'Ajouter au panier', epuise: 'Épuisé dans cette taille', hexBleu: '#7FD4E8', hexRose: '#F4B8D0' };
      try {
        var dEl = root.querySelector('[data-cgach-data]');
        if (dEl) variants = JSON.parse(dEl.textContent) || [];
      } catch (e) { variants = []; }
      try {
        var cEl = root.querySelector('[data-cgach-cfg]');
        if (cEl) {
          var c = JSON.parse(cEl.textContent);
          for (var k in c) { if (c[k]) cfg[k] = c[k]; }
        }
      } catch (e2) { /* défauts conservés */ }

      /* ---------- éléments ---------- */
      var prixEl = root.querySelector('[data-cg-prix]');
      var dimEl = root.querySelector('[data-cgach-dim]');
      var colNameEl = root.querySelector('[data-cgach-coloris-nom]');
      var taillesWrap = root.querySelector('[data-cgach-tailles]');
      var pastillesWrap = root.querySelector('[data-cgach-pastilles]');
      var blocTaille = root.querySelector('[data-cgach-bloc-taille]');
      var blocColoris = root.querySelector('[data-cgach-bloc-coloris]');
      var form = root.querySelector('[data-cgach-form]');
      var vidInput = root.querySelector('[data-cgach-vid]');
      var qteInput = root.querySelector('[data-cgach-qte-nb]');
      var btn = root.querySelector('[data-cgach-atc]');
      var btnTxt = root.querySelector('[data-cgach-atc-txt]') || btn;
      var imgBleu = root.querySelector('[data-cgach-img="bleu"]');
      var imgRose = root.querySelector('[data-cgach-img="rose"]');

      function fmt(n) { return n.toFixed(2).replace('.', ',') + ' €'; }

      /* ---------- tailles & coloris dérivés des variantes ---------- */
      var sizes = [], colors = [], i, sSeen = {}, cSeen = {};
      for (i = 0; i < variants.length; i++) {
        var o2 = variants[i].o2 == null ? '' : String(variants[i].o2);
        var o1 = variants[i].o1 == null ? '' : String(variants[i].o1);
        if (o2 && !sSeen[o2]) {
          sSeen[o2] = 1;
          var seg = o2.split(' — ');
          sizes.push({ o2: o2, label: seg[0].trim(), dim: (seg[1] || '').trim() });
        }
        if (o1 && !cSeen[o1]) {
          cSeen[o1] = 1;
          var low = o1.toLowerCase();
          var hex = '#CBD5DC';
          if (low.indexOf('bleu') >= 0) hex = cfg.hexBleu;
          else if (low.indexOf('rose') >= 0) hex = cfg.hexRose;
          colors.push({ label: o1, hex: hex });
        }
      }

      /* défauts : taille M si présente sinon la 1re ; coloris Bleu si présent sinon le 1er */
      var state = { size: '', color: '', qty: 1 };
      for (i = 0; i < sizes.length; i++) { if (sizes[i].label.toUpperCase() === 'M') { state.size = sizes[i].label; break; } }
      if (!state.size && sizes.length) state.size = sizes[0].label;
      for (i = 0; i < colors.length; i++) { if (colors[i].label.toLowerCase().indexOf('bleu') >= 0) { state.color = colors[i].label; break; } }
      if (!state.color && colors.length) state.color = colors[0].label;

      /* o2 commence par la taille sélectionnée ET o1 contient le coloris */
      function findVariant(sizeLabel, colorLabel) {
        for (var j = 0; j < variants.length; j++) {
          var v = variants[j];
          var vo2 = v.o2 == null ? '' : String(v.o2);
          var vo1 = v.o1 == null ? '' : String(v.o1);
          var okS = !sizeLabel || vo2.indexOf(sizeLabel) === 0;
          var okC = !colorLabel || vo1.toLowerCase().indexOf(colorLabel.toLowerCase()) >= 0;
          if (okS && okC) return v;
        }
        return null;
      }

      /* ---------- construction des sélecteurs ---------- */
      var sizeBtns = [], colorBtns = [];
      if (taillesWrap && sizes.length) {
        for (i = 0; i < sizes.length; i++) {
          (function (s) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'cgach-taille';
            var l = document.createElement('span'); l.className = 'cgach-taille-l'; l.textContent = s.label;
            b.appendChild(l);
            if (s.dim) {
              var d = document.createElement('span'); d.className = 'cgach-taille-d'; d.textContent = s.dim;
              b.appendChild(d);
            }
            var rep = cfg['rep' + s.label.toUpperCase()];
            if (rep) {
              var g = document.createElement('span'); g.className = 'cgach-taille-g'; g.textContent = rep;
              b.appendChild(g);
            }
            b.addEventListener('click', function () { state.size = s.label; update(); });
            taillesWrap.appendChild(b);
            sizeBtns.push({ el: b, s: s });
          })(sizes[i]);
        }
        if (blocTaille) blocTaille.removeAttribute('hidden');
      }
      if (pastillesWrap && colors.length) {
        for (i = 0; i < colors.length; i++) {
          (function (cObj) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'cgach-pastille';
            b.style.background = cObj.hex;
            b.setAttribute('aria-label', cObj.label);
            b.addEventListener('click', function () { state.color = cObj.label; update(); });
            pastillesWrap.appendChild(b);
            colorBtns.push({ el: b, c: cObj });
          })(colors[i]);
        }
        if (blocColoris) blocColoris.removeAttribute('hidden');
      }

      /* ---------- rendu de l'état ---------- */
      function update() {
        var j, v = findVariant(state.size, state.color);
        var vPrix = v || findVariant(state.size, '') || (variants.length ? variants[0] : null);
        var unit = vPrix && vPrix.price ? Number(vPrix.price) : 0;

        for (j = 0; j < sizeBtns.length; j++) {
          var on = sizeBtns[j].s.label === state.size;
          sizeBtns[j].el.classList[on ? 'add' : 'remove']('actif');
          if (on && dimEl) dimEl.textContent = sizeBtns[j].s.dim;
        }
        for (j = 0; j < colorBtns.length; j++) {
          var onC = colorBtns[j].c.label === state.color;
          colorBtns[j].el.classList[onC ? 'add' : 'remove']('actif');
          if (onC && colNameEl) colNameEl.textContent = colorBtns[j].c.label;
        }

        /* image selon le coloris */
        if (imgBleu && imgRose) {
          if (state.color.toLowerCase().indexOf('rose') >= 0) {
            imgRose.removeAttribute('hidden'); imgBleu.setAttribute('hidden', '');
          } else {
            imgBleu.removeAttribute('hidden'); imgRose.setAttribute('hidden', '');
          }
        }

        if (prixEl && unit) prixEl.textContent = fmt(unit);
        if (qteInput) qteInput.value = state.qty;
        if (vidInput && v) vidInput.value = v.id;

        if (btn && variants.length) {
          if (v && v.available) {
            btn.disabled = false;
            btnTxt.textContent = cfg.bouton + ' · ' + fmt(unit * state.qty);
          } else {
            btn.disabled = true;
            btnTxt.textContent = cfg.epuise;
          }
        }
      }

      /* ---------- quantité ---------- */
      var moins = root.querySelector('[data-cgach-moins]');
      var plus = root.querySelector('[data-cgach-plus]');
      if (moins) moins.addEventListener('click', function () { state.qty = Math.max(1, state.qty - 1); update(); });
      if (plus) plus.addEventListener('click', function () { state.qty = state.qty + 1; update(); });
      if (qteInput) qteInput.addEventListener('change', function () {
        var n = parseInt(qteInput.value, 10);
        state.qty = (isNaN(n) || n < 1) ? 1 : n;
        update();
      });

      /* ---------- ajout au panier (fetch ; repli natif sans JS/fetch) ---------- */
      if (form && window.fetch) {
        form.addEventListener('submit', function (ev) {
          ev.preventDefault();
          var v = findVariant(state.size, state.color);
          if (variants.length && (!v || !v.available)) return;
          var id = v ? v.id : parseInt(vidInput && vidInput.value, 10);
          if (!id) { form.submit(); return; }
          var prev = btnTxt.textContent;
          btn.disabled = true;
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: id, quantity: state.qty }] })
          }).then(function (r) {
            if (!r.ok) { throw new Error('cart'); }
            return r.json();
          }).then(function () {
            window.location.href = '/cart';
          }).catch(function () {
            alert("Impossible d'ajouter au panier — réessaie.");
            btn.disabled = false;
            btnTxt.textContent = prev;
            update();
          });
        });
      }

      update();

      /* ---------- animation fondu (sûre : contenu visible si le JS échoue) ---------- */
      if (root.classList.contains('cgx-anim') && 'IntersectionObserver' in window &&
          !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
        root.classList.add('cgx-ready');
        var els = root.querySelectorAll('.cgx-reveal');
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) { en.target.classList.add('cgx-in'); io.unobserve(en.target); }
          });
        }, { threshold: 0.15 });
        for (var z = 0; z < els.length; z++) io.observe(els[z]);
      }
    }

    function boot() {
      var nodes = document.querySelectorAll('[data-cgach-sid]');
      for (var i = 0; i < nodes.length; i++) cgachInit(nodes[i]);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();

    /* rechargement de section dans l'éditeur de thème */
    if (!window.__cgachHook) {
      window.__cgachHook = true;
      document.addEventListener('shopify:section:load', function (e) {
        var n = e.target && e.target.querySelector ? e.target.querySelector('[data-cgach-sid]') : null;
        if (n) cgachInit(n);
      });
    }
  })();
